export default __webpack_public_path__ + "static/media/eternals_gallery_preview.7070367a.jpg";